import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';
const api = axios.create({ baseURL: API_URL, headers: { 'Content-Type': 'application/json' } });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const staffingAPI = {
  signup: async (payload) => (await api.post('/staffing/signup', payload)).data,
  me: async () => (await api.get('/staffing/me')).data,
  team: async () => (await api.get('/staffing/team')).data,
  invite: async (email, name = '', position = 'Recruiter') =>
    (await api.post('/staffing/team/invite', { email, name, position })).data,
  revokeSub: async (uid) => (await api.post(`/staffing/team/${uid}/revoke`)).data,
  restoreSub: async (uid) => (await api.post(`/staffing/team/${uid}/restore`)).data,

  listCandidates: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await api.get(`/staffing/candidates?${q.toString()}`)).data;
  },
  getCandidate: async (id) => (await api.get(`/staffing/candidates/${id}`)).data,
  updateCandidate: async (id, data) => (await api.put(`/staffing/candidates/${id}`, data)).data,
  deleteCandidate: async (id) => (await api.delete(`/staffing/candidates/${id}`)).data,
  bulkUpload: async (files) => {
    const fd = new FormData();
    files.forEach(f => fd.append('files', f));
    return (await api.post('/staffing/candidates/bulk-upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
  },

  publicStaffingOrgs: async () => (await api.get('/staffing/orgs/public')).data,
};

export const adminStaffingAPI = {
  listOrgs: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await api.get(`/admin/staffing-orgs?${q.toString()}`)).data;
  },
  approveOrg: async (id) => (await api.post(`/admin/staffing-orgs/${id}/approve`)).data,
  revokeOrg: async (id) => (await api.post(`/admin/staffing-orgs/${id}/revoke`)).data,
  restoreOrg: async (id) => (await api.post(`/admin/staffing-orgs/${id}/restore`)).data,
  revokeUser: async (uid) => (await api.post(`/admin/staffing-users/${uid}/revoke`)).data,
  restoreUser: async (uid) => (await api.post(`/admin/staffing-users/${uid}/restore`)).data,
};

export const adminCandidatesAPI = {
  list: async (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.append(k, String(v)); });
    return (await api.get(`/admin/candidates?${q.toString()}`)).data;
  },
  revoke: async (uid) => (await api.post(`/admin/candidates/${uid}/revoke`)).data,
  restore: async (uid) => (await api.post(`/admin/candidates/${uid}/restore`)).data,
  walletBreakdown: async () => (await api.get('/admin/wallet-breakdown')).data,
};

export default api;
